<!-- Main container for the consignment product selection page -->
<div class="page-innder-body portlet light">
  <div class="portlet-body">
    <!-- Breadcrumb navigation -->
    @if (items && items.length > 0) {
      <div class="card flex justify-content-center mt-2 mb-2" style="border: none;">
        <p-breadcrumb class="no-border max-w-full" [model]="items" [home]="home"></p-breadcrumb>
      </div>
    }

    <!-- Toolbar with artist information and actions -->
    <div class="table-toolbar">
      <div class="p-2">
        @if (consignmentArtist) {
          <div class="row text-bg-light p-2 border">
            <div class="col-md-12">
              <div class="d-flex justify-content-between align-items-center border-bottom py-2">
                <!-- Artist details -->
                <div class="align-items-center">
                  <div class="text-start d-flex">
                    @if (consignmentArtist.ImgUrl) {
                      <img [src]="consignmentArtist.ImgUrl" class="rounded-circle cursor-pointer"
                        height="50"
                        (click)="viewArtistDetails(consignmentArtist.UserName!)" />
                    }
                    <div class="d-flex flex-column align-items-start ms-2">
                      <a href="javascript:void(0);" class="fs-4 cursor-pointer"
                        (click)="viewArtistDetails(consignmentArtist.UserName!)">
                        {{ consignmentArtist.Name }}
                      </a>
                      <div class="fs-5 d-flex flex-column align-items-start text-muted">
                        @if (consignmentArtist.BusinessName) {
                          <div class="small">
                            {{ 'consignmentProductSelection.tradingAs' | transloco: { name: consignmentArtist.BusinessName } }}
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Action buttons -->
                <div class="d-flex align-items-center">
                  <div>
                                    <p-button type="button" [label]="
                    acceptedConsignmentProductIds.length > 0
                      ? ('consignmentProductSelection.unselectAllCount' | transloco: { count: acceptedConsignmentProductIds.length })
                      : ('consignmentProductSelection.selectAll' | transloco)
                  " [outlined]="true" (click)="selectAllProducts()" class="me-2">
                    </p-button>
                  </div>
                                <p-button type="button" icon="fa fa-save" [label]="
                acceptedConsignmentProductIds.length > 0
                  ? ('consignmentProductSelection.acceptSelectedProductsCount' | transloco: { count: acceptedConsignmentProductIds.length })
                  : ('consignmentProductSelection.acceptSelectedProducts' | transloco)
              " [outlined]="true" (click)="showProductDetailsDialog()"
                    [disabled]="acceptedConsignmentProductIds.length == 0" class="me-2">
                  </p-button>
                  <div>
                    <i class="pi pi-chevron-down cursor-pointer text-secondary"
                    (click)="onShowArtistOverlay($event)" style="font-size: 1.25rem;"></i>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column mt-2">
                @if (consignment) {
                  <div class="small">
                    <span class="fw-semibold">{{ 'consignmentProductSelection.consignment' | transloco }}</span> ({{ consignment.Name }})
                  </div>
                }
                <!-- New: Dispatched time and comment (only if dispatched) -->
                @if (consignment && consignment.IsDispatched) {
                  <div class="small mt-1">
                    <div>
                      <span class="fw-semibold">{{ 'consignmentProductSelection.dispatchedOn' | transloco }}</span> {{ consignment.DispatchedTime |
                      date:'short' }}
                    </div>
                    @if (consignment.ConsignmentDispatchComment) {
                      <div class="mt-1">
                        {{ consignment.ConsignmentDispatchComment }}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Product grid -->
      @if (consignmentProducts && consignmentProducts.length > 0) {
        <ds-artwork-grid context="consignment-product-selection" #cps class="d-block my-4">
          @for (product of consignmentProducts; track product) {
            <ds-artwork-card
              [size]="cps.size"
              [imageUrl]="product.ProductImgUrl"
              [name]="product.Name"
              [price]="product.ArtistRevenue"
              [selected]="product.IsAccepted"
              (cardClick)="goToProductDetails(product)">
              <div actions class="mt-2 d-flex gap-2">
                <button pButton type="button" class="flex-grow-1 p-button-sm rounded-3"
                  [label]="product.IsAccepted ? ('consignmentProductSelection.unselect' | transloco) : ('consignmentProductSelection.select' | transloco)"
                  [icon]="product.IsAccepted ? 'fa fa-times' : 'fa fa-check'"
                  [ngClass]="product.IsAccepted ? 'p-button-secondary' : 'p-button-primary'"
                  (click)="selectProductTosync($event, product)">
                </button>
                <button pButton type="button" class="p-button-sm p-button-outlined rounded-3" icon="fa fa-info-circle"
                  [pTooltip]="'consignmentProductSelection.viewProductDetails' | transloco" tooltipPosition="top"
                  (click)="$event.stopPropagation(); showProductDeatils($event, product.Id)">
                </button>
              </div>
            </ds-artwork-card>
          }
        </ds-artwork-grid>
      }

        <!-- No products message -->
        @if (consignmentProducts.length === 0) {
          <div class="row my-2">
            <div class="col-12 text-center text-muted fs-5">{{ 'consignmentProductSelection.noProductsFound' | transloco }}</div>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Artist overlay panel -->
  @if (showArtistOverlayPanel && consignmentArtist) {
    <artist-overlay [visible]="showArtistOverlayPanel" [artistId]="consignmentArtist.Id!"
      (onClosed)="onArtistOverlayClosed($event)">
    </artist-overlay>
  }

  <!-- Comment dialog -->
  <p-dialog [header]="'consignmentProductSelection.addYourComment' | transloco" [(visible)]="showCommentDialog" [modal]="true" [style]="{'width': '430px'}">
    <form class="form-horizontal mt-2 px-3">
      <div class="text-muted small">
        <i class="fa fa-info-circle me-1"></i> {{ 'consignmentProductSelection.commentInfo' | transloco }}
      </div>
      <div class="form-group my-3">
        <div class="panel-container">
          <div class="panel-body">
            <textarea id="comments" pInputTextarea rows="3" name="comments"
              [(ngModel)]="selectedConsignmnetPoduct.ConsignmentAcceptComment"
              [placeholder]="'consignmentProductSelection.startTypingHere' | transloco" class="form-control">
            </textarea>
            <div class="emoji-icon position-absolute cursor-pointer fs-6" (click)="openEmojiDialog()"
              style="top: 60%; right: 2rem; transform: translateY(-50%);">
              (😍)
            </div>
            <button pButton type="button" class="p-button-outlined w-100 mt-2" [label]="'consignmentProductSelection.accept' | transloco"
              (click)="acceptConsignmentProducts($event)">
            </button>
          </div>
        </div>
      </div>
    </form>
  </p-dialog>

  <!-- Emoji picker dialog -->
  @if (displayEmojiDialog) {
    <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
      (emojiClick)="addEmoji($event)">
    </app-emoji-list>
  }

  <!-- Upgrade account dialog -->
  <p-dialog [(visible)]="displayUpgreadAccountDialog" [header]="'consignmentProductSelection.upgradeYourAccount' | transloco" [closable]="true" [modal]="true"
    [style]="{width: '450px'}">
    <div class="dialog-content">
      <div class="alert alert-warning p-4 rounded-3 border-0 shadow-lg mb-4">
        <div class="d-flex align-items-center">
          <i class="pi pi-info-circle text-warning fs-3 me-3"></i>
          <div>
            <strong>{{ 'consignmentProductSelection.upgradeNeeded' | transloco }}</strong>
            <p class="mb-2">
              {{ 'consignmentProductSelection.upgradeNeededText' | transloco }}
            </p>
          </div>
        </div>
      </div>
      <p class="lead p-2">
        {{ 'consignmentProductSelection.upgradeLeadText' | transloco }}
      </p>
      <div class="text-center mt-4">
        <a href="javascript:void(0);" (click)="onUpgradeAccount()">
          <img src="assets/images/upgrade-nag-button-200h.png" width="300" [alt]="'consignmentProductSelection.upgradePlan' | transloco"
            class="rounded shadow-lg img-fluid" />
          </a>
        </div>
      </div>
    </p-dialog>

    <!-- Stripe payment plans dialog -->
    @if (isStripeDisplayPlansDialogVisible) {
      <stripe-payment-plan [isStripePaymentPlansDialogVisible]="isStripeDisplayPlansDialogVisible"
        [stripeAllPlans]="stripePlans" (onCloseStripePaymentPlanDailog)="onCloseStripePaymentDailog($event)">
      </stripe-payment-plan>
    }

    <!-- Product details dialog -->
    @if (showProductDialog) {
      <app-product-details-dialog [(showProductDialog)]="showProductDialog" [productId]="selectedProductId"
        (onClose)="closeProductDialog()">
      </app-product-details-dialog>
    }